import React, { useState, useEffect, ChangeEventHandler, FocusEventHandler } from "react";
import { ISelectListItem, Nullable } from "../types"
import Checkbox from "./Checkbox"
import Input from "../../FormUi/Input";

interface IPropsType {
    items: Array<ISelectListItem>,
    selectedItems: any[],
    onChange: (selectedItem: ISelectListItem, add: boolean) => void
    allowMultiple: boolean,
    showValidation?: boolean,
    errorMessage?: string,
    name: string,
    checkBoxAdditionalClass: string,
    rowCount: number,
    disabled: boolean
}

function checkboxList(props: IPropsType) {
    const [separatedItems, setSeparatedItems] = useState<Array<Array<ISelectListItem>>>([]);
    
    useEffect(() => {
        var resultArray = [];
        if (props.items && props.items.length > 0) {

            var i = 0;


            while ((i + props.rowCount) <= props.items.length) {
                resultArray.push(props.items.slice(i, i + props.rowCount));
                i += props.rowCount;
            }
           
            if (i < props.items.length) {
                resultArray.push(props.items.slice(i));
            }
           
            //for (var i = 0; i < props.items.length; i++) {
            //    if ((i + 1) / props.rowCount == 0) {
            //        resultArray.push(props.items.slice());
            //    }
            //}
        }
        setSeparatedItems(resultArray);

    }, [props.items]);

    return (
        <React.Fragment>
            <div className="rowLists">
                
            {separatedItems && separatedItems.map(x => {
                return (
                    <div className="columItems">
                        {x.map(y => {
                            return (
                                <React.Fragment>
                                    <Input
                                        field={{ name: props.name + y.Value, title: y.Text, element: "checkbox" }}
                                        value={props.selectedItems.includes(parseInt(y.Value))}
                                        disabled={props.disabled}
                                        onChange={(name, checked) => {
                                            props.onChange(y, checked);
                                        }}
                                    />
                                    {/*<Checkbox*/}
                                    {/*     additionalClass={props.checkBoxAdditionalClass}*/}
                                    {/*     label={y.Text}*/}
                                    {/*     name={props.name + y.Value}*/}
                                    {/*     value={props.selectedItems.includes(parseInt(y.Value))}*/}
                                    {/*     disabled={props.disabled}*/}
                                    {/*     onChange={(e) => {*/}
                                    {/*        props.onChange(y, e.target.checked);*/}
                                    {/*     }}*/}
                                    {/*/>*/}
                                </React.Fragment>
                            )
                           
                        })}
                    </div>
                )
            })}
                {props.showValidation && <p className="errorText">{props.errorMessage}</p>}

            </div>
        </React.Fragment>

    );

}

export default checkboxList;